import {
  ROOM_ACCESS_STORAGE_KEY,
} from "./roomAccess";
import {
  ACCESS_SCOPE_STORAGE_KEY,
  BOOKING_OWNER_CONTEXT_STORAGE_KEY,
  CAPABILITIES_STORAGE_KEY,
} from "./journeyAccess";

export const getLS = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
};

export const setLS = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const clearGuestData = () => {
  [
    "apaleo-property-id",
    "arrival",
    ACCESS_SCOPE_STORAGE_KEY,
    "booker",
    BOOKING_OWNER_CONTEXT_STORAGE_KEY,
    CAPABILITIES_STORAGE_KEY,
    "checkout",
    "email",
    "guest-access",
    "guest-firstname",
    "guest-journey-api",
    "guest-access-token",
    "guest-lastname",
    "hotel-id",
    "hotel-name",
    "is_valid_in_pms",
    "online-checkin",
    "pin-code",
    "reservation-code",
    "reservation-state",
    "room-number",
    "rooms",
    ROOM_ACCESS_STORAGE_KEY,
    "self-checkin-url",
    "telephone",
  ]
    .forEach(key => localStorage.removeItem(key));
};

export const storeGuestData = (guest, room, guestArray, email, phone) => {
  localStorage.setItem("guest-firstname", guest.first_name);
  localStorage.setItem("guest-lastname", guest.last_name);
  localStorage.setItem("email", email);
  localStorage.setItem("telephone", phone);

  if (room) {
    localStorage.setItem("room-number", room.name);
    localStorage.removeItem("pin-code");
    if (room.departure) {
      localStorage.setItem("departure", room.departure);
    }
  }

  if (guestArray) {
    const rooms = JSON.parse(localStorage.getItem("rooms") || "[]");

    // Loop through rooms
    rooms.forEach((room) => {
      room.guests = room.guests.map((g) => {
        if (
          g.first_name.toLowerCase() === guestArray.first_name.toLowerCase() &&
          g.last_name.toLowerCase() === guestArray.last_name.toLowerCase()
        ) {
          return guestArray; // Replace guest
        }
        return g; // Keep original
      });
    });

    // Save the updated rooms back to localStorage
    localStorage.setItem("rooms", JSON.stringify(rooms));
  }
};



export const findMatchingGuest = ({firstName,lastName}) => {
  const rooms = JSON.parse(localStorage.getItem("rooms") || "[]");
  for (const room of rooms) {
    for (const guest of room.guests) {
      if (
        guest.first_name?.toLowerCase() === firstName.toLowerCase() &&
        guest.last_name?.toLowerCase() === lastName.toLowerCase()
      ) {
        return { guest, room };
      }
    }
  }
  return { guest: null, room: null };
};
